import { getFactIcon } from "common/utils/facts";
import Icon from "common/components/Icon";
import MarkdownParser from "common/components/MarkdownParser";

import { IProductLineDetails } from "../types";

import styles from "../styles/ProductLineQuickFacts.module.less";

type ProductLineQuickFactsProps = { productLine: IProductLineDetails };

const ProductLineQuickFacts = ({ productLine }: ProductLineQuickFactsProps) => {
  return (
    <div className={styles.facts}>
      {productLine.facts.map((fact) => {
        const icon = getFactIcon(fact.icon);

        return (
          <div className={styles.fact} key={fact.value}>
            <Icon className={styles.icon} fixedWidth={true} icon={icon} />
            <p className={styles.description}>
              <MarkdownParser.Inline markdown={fact.value} />
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default ProductLineQuickFacts;
